<template>
  <div class="clearfix">
    <div
      id="reassignSubmissionModal"
      ref="reassignSubmissionModal"
      class="reveal reassign-submission-modal"
      data-reveal
    >
      <div class="tender-confirm clearfix">
        <div :class="{'required-error-highlight': inputRequireHighlight && !newPersonInCharge}">
          <label class="reassign-submission-title">{{ $t('action.reAssignTo') }}</label>
          <HKLSelect
            :value="newPersonInChargeId || undefined"
            class="next-design-reviewer-selector"
            :options="reviewerHklOptions"
            :showSearch="true"
            placeholder=""
            @change="onReviewerChange"
          />
        </div>
      </div>
      <div class="row align-right nav_btn">
        <button
          id="confirm_no"
          type="button"
          class="btn btn--darkblue"
          data-close
        >{{ $t('action.cancel') }}</button>
        <button
          id="confirm_ok"
          type="button"
          class="btn btn--orange"
          @click="changeAssignee()"
        >{{ $t('action.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import mutationTypes from '@/store/mutation-types'
import { PermTypeMapKeys } from '@/utils/aclHelper'
import { getUsersForSameBuilding } from '../utils'

export default {
  name: 'ReassignSubmissionModal',
  components: {
    HKLSelect,
  },
  props: {
    confirmCallback: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      cc: '',
      bcc: '',
      buildingUsers: [],
      newPersonInCharge: '',
      newPersonInChargeId: null,
      inputRequireHighlight: false,
    }
  },
  computed: {
    ...mapGetters('tenantProject', ['currentTenantSubmission', 'currentTenantProject', 'activeSubmissionIndex']),
    designComment () {
      return JSON.parse(JSON.stringify(deep(this.currentTenantSubmission, 'designComment') || {}))
    },
    reviewerHklOptions () {
      return (this.buildingUsers || []).map((opt) => ({
        name: opt.displayPicName || opt.displayName,
        value: opt.id,
      }))
    },
  },
  beforeDestroy () {
    if (this.reassignSubmissionModal) {
      this.reassignSubmissionModal.destroy()
    }
    $(this.$refs.reassignSubmissionModal).remove()
  },
  methods: {
    ...mapMutations('tenantProject', {
      updateFieldByPath: mutationTypes.TENANT_PROJECT_UPDATE_FIELD_PATH,
    }),
    async init () {
      if (!this.reassignSubmissionModal) {
        this.reassignSubmissionModal = await new Foundation.Reveal($('#reassignSubmissionModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
    },
    async openModal () {
      await this.init()
      const permType = PermTypeMapKeys.TENANT_PROJECT_DESIGN
      const tenancy = this.currentTenantProject.tenancy
      const currentReviewer = this.currentTenantSubmission.designManager || ''
      this.buildingUsers = await getUsersForSameBuilding(tenancy, permType, currentReviewer, { includeTrReps: true })
      this.buildingUsers = this.buildingUsers.sort((a, b) => a.displayName.localeCompare(b.displayName))
      this.newPersonInCharge = ''
      this.newPersonInChargeId = null
      this.reassignSubmissionModal.open()
    },
    closeModal () {
      if (this.reassignSubmissionModal) {
        this.reassignSubmissionModal.close()
      }
    },
    onReviewerChange (id) {
      this.newPersonInChargeId = id || null
      this.newPersonInCharge = (this.buildingUsers || []).find((opt) => opt.id === id) || ''
    },
    async changeAssignee () {
      if (!this.newPersonInCharge || !this.newPersonInCharge.id) {
        this.inputRequireHighlight = true
        return
      }
      await this.confirmCallback(undefined, this.newPersonInCharge.id)
      this.closeModal()
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';
@import '~styles/popup';
</style>

<style lang="scss">
$tender-font-color: #0C3A58;
#reassignSubmissionModal {
  width:480px;
  .reassign-submission-title {
    text-transform: capitalize;
    margin-top: 15px;
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 1.43;
    font-weight: bold;
    text-align: left;
    color: $tender-font-color;
  }
}
</style>
